import {Component, OnDestroy, OnInit} from '@angular/core';
import {ProjectConstants} from '../../../project-constants';
import {FormBuilder, FormGroup, NgForm, Validators} from '@angular/forms';
import {Subscription} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import * as toastr from 'toastr';
import {ProviderAnagrafService} from '../../../general-services/service-provider-anagraf/provider-anagraf.service';
import {ProviderModel} from '../../../../models/ProviderModel';

@Component({
  selector: 'app-new-provider-anagraf',
  templateUrl: './new-provider-anagraf.component.html',
  styleUrls: ['./new-provider-anagraf.component.scss']
})
export class NewProviderAnagrafComponent extends ProjectConstants implements OnInit, OnDestroy {
  provider: ProviderModel;
  formValidator: FormGroup;
  formBuilder: FormBuilder;
  saveSubscribe: Subscription;

  constructor(private route: ActivatedRoute, private router: Router,
              private providerService: ProviderAnagrafService) {
    super();

    this.provider = new ProviderModel();

    this.formBuilder = new FormBuilder();

    this.formValidator = this.formBuilder.group({
      cod: [this.provider.cod, [Validators.required]],
      description: [this.provider.description, [Validators.required]]
    });
  }

  ngOnInit() {

  }

  cancel(event: any) {
    event.preventDefault();
    this.router.navigate([this.LINKS.MASTER_DATA + this.LINKS.ANAGRAPH.PROVIDER_ANAGRF]);
  }

  save(event: any, form: NgForm, clickSalva ?: boolean) {
    if (event.key === 'Enter' || clickSalva) {
      event.preventDefault();
      this.provider.cod = this.formValidator.value.cod;
      this.provider.description = this.formValidator.value.description;
      this.saveSubscribe = this.providerService.save(this.providerService.baseUrl, this.provider).subscribe(
        (result: any) => {
          if (result === -1) {
            toastr.options.timeout = 5000;
            toastr.warning('Duplicate item, Provider Cod already exists', 'Warning');
          } else {
            toastr.success('Provider was added with success', 'Success');
            this.router.navigate([this.LINKS.MASTER_DATA + this.LINKS.ANAGRAPH.PROVIDER_ANAGRF]);
          }
        });
    }
  }

  ngOnDestroy(): void {
    if (this.saveSubscribe) {
      this.saveSubscribe.unsubscribe();
    }
  }

  // convenience getter for easy access to form fields
  get fv() { return this.formValidator.controls; }

}

